module.exports = __webpack_public_path__ + "static/media/pzu-vwMSPsMzdCUwi3C7vVPi0ygtgetz9q.88b91699.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pzu-vwMSPsMzdCUwi3C7vVPi0ygtgetz9q.webp
// module id = 650
// module chunks = 0